import { Box, Divider } from "@mui/material";

import { User } from "../../../../../types/types/user.types";

import About from "../../../components/About";
import Overview from "../../../components/OverView";
import Trophies from "../../../components/Trophies";
import Experience from "../../../components/Experience";
import Testimonials from "../../../components/Testimonials";
import EndorsedSkills from "../../../components/EndorsedSkills";

import PlayerAgent from "./PlayerAgent";
import PlayerPosition from "./PlayerPosition";

interface HomeTabProps {
  profile?: User;
  isLoading: boolean;
}

const HomeTab = ({ profile, isLoading }: HomeTabProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <About about={profile?.bio} isLoading={isLoading} />
      <PlayerAgent />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          background: "#FFF",
          padding: "20px",
        }}
      >
        <Overview overViewTitle="playerOverview" overViewList={profile?.overview} isLoading={isLoading} />
        <Divider orientation="horizontal" flexItem sx={{ backgroundColor: "var(--gray-200, #EAECF0)" }} />
        <PlayerPosition
          mainPosition={profile?.primaryPosition}
          secondaryPosition={profile?.otherPosition}
          isLoading={isLoading}
        />
      </Box>
      <EndorsedSkills />
      <Experience />
      <Trophies />
      <Testimonials />
    </Box>
  );
};

export default HomeTab;
